module.exports = __webpack_public_path__ + "static/media/example-work04.633c5341.jpg";